import React from 'react';
import '../assets/css/main.css';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer id="footer" className="footer light-background">
      <div className="container footer-top">
        <div className="row gy-4">
          <div className="col-lg-4 col-md-6 footer-about">
            <a href="index.html" className="d-flex align-items-center">
              <span className="sitename">MyCareerGems</span>
            </a>
            <div className="footer-contact pt-3">
              <p style={{ textAlign: "justify" }}> MyCareergems EduTech - Door No. 43, Plot No. 18, Madurai Meenakshipuram, Urapakkam, Chengalpattu, Tamil Nadu - 603210</p>
      
              <hr></hr>
              <p className="mt-3"><strong>Phone:</strong> <span>+91 744 920 6853</span></p>
              <p><strong>Email:</strong> <span>support@mycareergems.com</span></p>
            </div>
          </div>

          <div className="col-lg-2 col-md-3 footer-links">
            <h4>Quick Links</h4>
            <ul>
              <li><i className="bi bi-chevron-right"></i> <Link to="/">Home</Link></li>
              <li><i className="bi bi-chevron-right"></i> <Link to="/about">About Us</Link></li>
              <li><i className="bi bi-chevron-right"></i> <Link to="/updates">Updates</Link></li>
              <li><i className="bi bi-chevron-right"></i> <Link to="/pricing">Pricing</Link></li>
            </ul>
          </div>

          <div className="col-lg-2 col-md-3 footer-links">
            <h4>Our Services</h4>
            <ul>
              <li><i className="bi bi-chevron-right"></i> <Link to="/pricing">Career Counseling</Link></li>
              <li><i className="bi bi-chevron-right"></i> <Link to="/pricing">Admission Guidance</Link></li>
              <li><i className="bi bi-chevron-right"></i> <Link to="/pricing">Personalized Mentorship</Link></li>
              <li><i className="bi bi-chevron-right"></i> <Link to="/pricing">Test Preparation</Link></li>
            </ul>
          </div>

          <div className="col-lg-4 col-md-12">
            <h4>Stay Connected</h4>
            <p>Follow us on social media for the latest updates, tips, and career opportunities.</p>
            <div className="social-links d-flex">
              <a href="https://www.facebook.com/share/15ft8S3g44/"><i className="bi bi-facebook"></i></a>
              <a href="https://www.instagram.com/mycareergems_mcg?utm_source=qr&igsh=MWpxeDdneTc2a2ZtdQ=="><i className="bi bi-instagram"></i></a>
            </div>
          </div>
        </div>
      </div>

      <div className="container copyright text-center mt-4">
        <p>© <span>Copyright</span> <strong className="px-1 sitename">MyCareerGems</strong> <span>All Rights Reserved</span></p>
        {/* <p className="credits">
          Designed by <a href="https://bootstrapmade.com/">BootstrapMade</a><strong></strong>
        </p> */}
      </div>

    </footer>
  );
};

export default Footer;
